<div class="page-header-container">
    <div class="page-title">
        {{'specialOffers.title' | translate}}
    </div>
</div>
<div class="d-flex justify-content-center justify-content-lg-end filter-container">
    <button *ngIf="activeFilterCount <= 0" class="btn white-btn text-uppercase" (click)="filterHandler()">
        {{'specialOffers.filter' | translate}}
    </button>
    <div class="buttons-group-box active-filters-reset" *ngIf="activeFilterCount > 0">
        <div class="btn-group" role="group">
            <button class="btn white-btn text-uppercase" (click)="filterHandler()">
                <span>{{'specialOffers.filterActive' | translate}}</span>
            </button>
            <button class="btn white-btn" (click)="resetFiltersHandler()">
                <span class="active-filters-badge">{{activeFilterCount}}</span>
                <i class="app-icon icon icon-close-circle-fill icon-lg"></i>
            </button>
        </div>
    </div>
    <div class="buttons-group-box table-view-mode-switch d-none d-lg-flex">
        <div class="btn-group" role="group">
            <button class="btn white-btn" (click)="toggleViewMode(TABLE_VIEW_MODES.LIST_VIEW)"
                [disabled]="tableViewMode === TABLE_VIEW_MODES.LIST_VIEW">
                <i class="app-icon icon icon-view-list icon-lg me-2"></i>
                <span>{{ 'common.listView' | translate }}</span>
            </button>
            <button class="btn white-btn" (click)="toggleViewMode(TABLE_VIEW_MODES.CARDS_VIEW)"
                [disabled]="tableViewMode === TABLE_VIEW_MODES.CARDS_VIEW">
                <i class="app-icon icon icon-view-grid icon-lg me-2"></i>
                <span>{{ 'common.cardsView' | translate }}</span>
            </button>
        </div>
    </div>
    <button class="btn primary-btn" (click)="navigateAddSpecialOfferHandler()">
        <i class="app-icon icon icon-add icon-xl me-2"></i>
            {{'specialOffers.addNewButton' | translate}}
    </button>
</div>

<div class="d-flex flex-column align-items-center my-5 my-lg-0" *ngIf="!hasData">
    <no-records-placeholder
        [showNoRecordsHeader]="true"
        [isActiveFilter]="activeFilterCount > 0"
        (clickHereEvent)="resetFiltersHandler()">
    </no-records-placeholder>
</div>

<special-offer-card-view
    *ngIf="(tableViewMode === TABLE_VIEW_MODES.CARDS_VIEW || !windowSizeLgUp) && hasData"
    [specialOffers]="specialOffers"
    [props]="props"
    (deleteSpecialOffer)="deleteSpecialOffer($event)"
    (stopSpecialOffer)="refreshSpecialOfferList()">
</special-offer-card-view>

<special-offer-list-view
    *ngIf="(tableViewMode === TABLE_VIEW_MODES.LIST_VIEW && windowSizeLgUp) && hasData"
    [specialOffers]="specialOffers"
    [props]="props"
    (deleteSpecialOffer)="deleteSpecialOffer($event)"
    (stopSpecialOffer)="refreshSpecialOfferList()">
</special-offer-list-view>

<button *ngIf="showBackToTop" type="button" class="btn btn-scroll-to-top" (click)="scrollToTop()">
    <i class="app-icon icon icon-back-to-top icon-xl"></i>
</button>
